const Cases = (domEl) => {
	if(!domEl) {
		return null;
	}

	const options = {
		root: null,
		rootMargin: '200px',
		threshold: 0.5,
	};

	const callback = (entries, observer) => {
		entries.forEach(entry => {
			const postCase = entry.target;

			if(entry.isIntersecting) {
				postCase.classList.add('js-initialize');
				postCase.classList.add('js-in-view');

				const videoPlaceholder = postCase.querySelector('.video-placeholder');
				const video = postCase.querySelector('.video-placeholder video');

				if(!video && videoPlaceholder) {
					const videoSrc = videoPlaceholder.dataset.src;
					const videoElement = document.createElement('video');
					videoElement.src = videoSrc;
					videoElement.autoplay = true;
					videoElement.loop = true;
					videoElement.muted = true;
					videoElement.playsInline = true;
					videoPlaceholder.appendChild(videoElement);
					videoElement.play();
				}
				else if(video) {
					video.play();
				}
			}
			else {
				postCase.classList.remove('js-in-view');

				const video = postCase.querySelector('.video-placeholder video');
				if(video) {
					video.pause();
				}
			}
		});
	};

	const observer = new IntersectionObserver(callback, options);

	const postCases = domEl.querySelectorAll('.post-case');
	postCases.forEach(postCase => observer.observe(postCase));
};

export default Cases;